var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"GroupPush"}},[_c('appHeader',{attrs:{"hasBackTool":true,"targetRouterName":_vm.route,"title":'顧客篩選結果'}}),_c('router-view',{staticClass:"content-body-hasFooter",staticStyle:{"padding-top":"72px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }